import { Rate } from 'antd';
import Styles from './assets/styles.scss';
import { IRateProps } from './entities';

const BCRate = (props: IRateProps) => {
	Styles;

	const onChange = (value: number) => {
		props.onChange?.(value || null);
	};

	const onHoverChange = (value: number) => {
		props.onHoverChange?.(value);
	};

	return (
		<Rate
			allowClear={props.allowClear}
			allowHalf={props.allowHalf}
			character={props.character}
			className={props.className}
			count={props.count}
			defaultValue={props.defaultValue}
			disabled={props.disabled || props.readOnly}
			style={props.style}
			tooltips={props.tooltips}
			value={props.value}
			onChange={onChange}
			onHoverChange={onHoverChange}
		/>
	);
};

export default BCRate;
export { BCRate, IRateProps };
